/**
 * Custom Test Types (056) — canonical unit -> short display label,
 * replacing the duplicated `unit === 'seconds' ? 'sec' : 'in'` binary
 * that used to live independently in TeamTestingStation.js,
 * PersonalTestingStation.js, AttemptInputGroup.js, and DrillHistory.js.
 * That binary silently mislabeled anything but the original two units as
 * "in" — this is the one place a new unit's label is defined, with a
 * safe fallback that never lies about an unrecognized unit.
 */
const UNIT_LABELS = {
  seconds: 'sec',
  inches: 'in',
  mph: 'mph',
  reps: 'reps',
  pounds: 'lb',
};

/** Short display label for a test_types.unit value. Falls back to the
 * raw unit string itself for anything not yet in the map — never
 * defaults to "in", which would misrepresent an unrecognized future
 * unit as a distance. */
export function unitLabel(unit) {
  if (unit === null || unit === undefined) return '';
  return Object.prototype.hasOwnProperty.call(UNIT_LABELS, unit) ? UNIT_LABELS[unit] : unit;
}
